/**
 * Lives in its own file (rather than inline in the Razor view) so we can
 * tighten CSP later without rewriting markup, and so the reload interval is
 * a data-attribute the controller can drive instead of a magic number in HTML.
 *
 * The empty-state has no sign-in form, so reload can't interrupt a
 * participant mid-checkin — that's enforced by Razor only emitting the
 * data-board-kiosk-empty container when no meeting resolved.
 */
(function () {
  if (typeof document === "undefined") {
    return;
  }

  function arm() {
    var el = document.querySelector("[data-board-kiosk-empty][data-reload-ms]");
    if (!el) {
      return;
    }
    var ms = parseInt(el.getAttribute("data-reload-ms"), 10);
    if (!Number.isFinite(ms) || ms < 1000) {
      return;
    }
    window.setTimeout(function () {
      window.location.reload();
    }, ms);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arm);
  } else {
    arm();
  }
})();
